import { render, staticRenderFns } from "./TabContentCreate.vue?vue&type=template&id=4165707a&scoped=true&"
import script from "./TabContentCreate.vue?vue&type=script&lang=js&"
export * from "./TabContentCreate.vue?vue&type=script&lang=js&"
import style0 from "./TabContentCreate.vue?vue&type=style&index=0&id=4165707a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4165707a",
  null
  
)

export default component.exports